export default __webpack_public_path__ + "b75a74e14cefa3c0a7b64ee109da86a0.svg";